import ApiCrud from "./api-crud";

class TareaService extends ApiCrud {
  resource = "tareas";
  primaryKey = "idtarea";
}

export default new TareaService();
